import Footer from "../../footer"
import NavBar from "../../nav"

const MinimumEquipmentList = () => {
  return <div className='minimum-equipment-list'>
    <NavBar />
    <div>
    <section className="clean-block pfa-content clearfix">
			<div className="divider sections">
				<h1>Minimum Equipment List (MELs)</h1>
				<div className="headline-divider sections"></div>
				<h2>Developed to your specific aircraft configuration or fleet.</h2>
			</div>
		</section>
    <section className="clean-block clearfix">	
			<div className="container content-container about-container">	
				<div className="prose">With over twenty years of experience developing Minimum Equipment Lists (MELs) Fly Compliant, LLC produces a compliant MEL per FAA guidance. MELs are developed to a specific aircraft configuration or fleet, including operations and maintenance procedures. As MELs are revised or procedures are updated clients using our iPad app LevelFlight Mobile will be notified of a revision, ensuring a compliant MEL.</div>
				<div className="prose not-first">As a participant of the FAA Minimum Equipment List working group we have the latest guidance and best operating practices for developing MELs. Additionally we have developed a MEL job aid detailing all applicable guidance documents to assist Principal Inspector's in the approval process.</div>
				<div className="prose not-first"><span className="highlight">Note:</span> For part 91 operators the FAA will sunset D095 and operators will need D195. AC 91-67A is in draft reference <a href="/assets/pdf/AC_91-67_Cancellation_Memo.pdf" target="_blank" rel="noreferrer">FAA Cancellation Memo AC 91-67.</a></div>
			</div>
		</section>
    </div>
    <Footer />
  </div>
}

export default MinimumEquipmentList